export default __webpack_public_path__ + "static/media/title-winners_vi@2x.947b4ecb.png";